import React from "react";
import Botao from "../../botao";

function ButtonTooltip(
    className,
    content,
    src,
    type,
    onClick,
    style,
    disabled,
    width,
    height
) {
    return (
        <Botao type={type} style={style} onClick={onClick} disabled={disabled}>
            <img src={src} width={width} height={height} alt={content}/>
        </Botao>
    );
}

export default ButtonTooltip;
